var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 3.33073H14.1665V2.4974C14.1665 2.27638 14.0787 2.06442 13.9224 1.90814C13.7661 1.75186 13.5542 1.66406 13.3332 1.66406C13.1122 1.66406 12.9002 1.75186 12.7439 1.90814C12.5876 2.06442 12.4998 2.27638 12.4998 2.4974V3.33073H7.49984V2.4974C7.49984 2.27638 7.41204 2.06442 7.25576 1.90814C7.09948 1.75186 6.88752 1.66406 6.6665 1.66406C6.44549 1.66406 6.23353 1.75186 6.07725 1.90814C5.92097 2.06442 5.83317 2.27638 5.83317 2.4974V3.33073H4.1665C3.50346 3.33073 2.86758 3.59412 2.39874 4.06296C1.9299 4.5318 1.6665 5.16769 1.6665 5.83073V15.8307C1.6665 16.4938 1.9299 17.1297 2.39874 17.5985C2.86758 18.0673 3.50346 18.3307 4.1665 18.3307H15.8332C16.4962 18.3307 17.1321 18.0673 17.6009 17.5985C18.0698 17.1297 18.3332 16.4938 18.3332 15.8307V5.83073C18.3332 5.16769 18.0698 4.5318 17.6009 4.06296C17.1321 3.59412 16.4962 3.33073 15.8332 3.33073ZM16.6665 15.8307C16.6665 16.0517 16.5787 16.2637 16.4224 16.42C16.2661 16.5763 16.0542 16.6641 15.8332 16.6641H4.1665C3.94549 16.6641 3.73353 16.5763 3.57725 16.42C3.42097 16.2637 3.33317 16.0517 3.33317 15.8307V9.9974H16.6665V15.8307ZM16.6665 8.33073H3.33317V5.83073C3.33317 5.60972 3.42097 5.39775 3.57725 5.24147C3.73353 5.08519 3.94549 4.9974 4.1665 4.9974H5.83317V5.83073C5.83317 6.05174 5.92097 6.2637 6.07725 6.41998C6.23353 6.57626 6.44549 6.66406 6.6665 6.66406C6.88752 6.66406 7.09948 6.57626 7.25576 6.41998C7.41204 6.2637 7.49984 6.05174 7.49984 5.83073V4.9974H12.4998V5.83073C12.4998 6.05174 12.5876 6.2637 12.7439 6.41998C12.9002 6.57626 13.1122 6.66406 13.3332 6.66406C13.5542 6.66406 13.7661 6.57626 13.9224 6.41998C14.0787 6.2637 14.1665 6.05174 14.1665 5.83073V4.9974H15.8332C16.0542 4.9974 16.2661 5.08519 16.4224 5.24147C16.5787 5.39775 16.6665 5.60972 16.6665 5.83073V8.33073Z",
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.99984,
    cy: 11.6693,
    r: 0.833333,
    fill: "#333333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.99984,
    cy: 14.9974,
    r: 0.833333,
    fill: "#333333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.33333,
    cy: 11.6693,
    r: 0.833333,
    fill: "#333333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.33333,
    cy: 14.9974,
    r: 0.833333,
    fill: "#333333"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6668,
    cy: 11.6693,
    r: 0.833333,
    fill: "#333333"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9998,
    cy: 11.6693,
    r: 0.833333,
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.1d1423fc2041b1e75c062e94a692e937.svg";
export { ForwardRef as ReactComponent };